stateProviders.push({
    name: 'schoolside.settings.taxDocuments.documentsToCollect',
    url: '/documentsToCollect',
    templateUrl: 'fast/submodules/schoolside/settings/taxDocuments/documentsToCollect/partials/documentsToCollect.html?v=' + versionNo,
    controller: 'DocumentsToCollectController',
    resolve:
    {
        school: function(SchoolModelService, authServiceFactory)
        {
            return SchoolModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        account: function(SchoolTaxModelService, authServiceFactory)
        {
            return SchoolTaxModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        documents: function(DocumentsModelService, authServiceFactory)
        {
            return DocumentsModelService.resolveData(authServiceFactory.getAuth().schoolID);
        },
        affectedFamilies: function(TaxSettingAffectedFamiliesModelService, authServiceFactory) {
            return TaxSettingAffectedFamiliesModelService.get(authServiceFactory.getAuth().schoolID);
        }
    }
});

stateProviders.push({
    name: 'schoolside.settings.taxDocuments.documentsToCollect.retro',
    templateUrl: 'fast/submodules/schoolside/settings/taxDocuments/documentsToCollect/partials/retroModal.html?v=' + versionNo,
    controller: 'RetroModalController'
});

stateProviders.push({
    name: 'schoolside.settings.taxDocuments.documentsToCollect.dtc',
    templateUrl: 'fast/submodules/schoolside/settings/taxDocuments/documentsToCollect/partials/documentsToCollectModal.html?v=' + versionNo,
    controller: 'DocumentsToCollectModalController'
});